// LUMINA · frontend/src/constants/dharmaActivities.js
// Phase 59D: 四大事业法静态配置 — 息增怀诛
// Static config avoids DB exposure for core Dharma categorization.

export const FOUR_ACTIVITIES = [
  {
    id: "pacifying",
    name_zh: "息 · 平息",
    name_en: "Pacifying",
    emoji: "💚",
    color: "#4CAF50",
    bg: "rgba(76,175,80,0.07)",
    border: "rgba(76,175,80,0.25)",
    description: "平息恐惧、病障与内外障碍",
    detail: "息法以慈悲为根，平息一切内外障碍——从身体病苦到心理恐惧，从外在违缘到内在烦恼。绿度母是息法的根本本尊。",
    deities: [
      {
        name_zh: "绿度母",
        name_en: "Green Tara",
        description: "救八难·满众愿·快速响应苦难",
        credential_key: "tara",
      },
      {
        name_zh: "白度母",
        name_en: "White Tara",
        description: "长寿·健康·平息病苦与恐惧",
        credential_key: null,
      },
      {
        name_zh: "药师佛",
        name_en: "Medicine Buddha",
        description: "疗愈身心·清净病苦",
        credential_key: null,
      },
    ],
  },
  {
    id: "enriching",
    name_zh: "增 · 增益",
    name_en: "Enriching",
    emoji: "💛",
    color: "#C9A84C",
    bg: "rgba(212,175,55,0.07)",
    border: "rgba(212,175,55,0.3)",
    description: "增益财富、事业与修行资粮",
    detail: "增法以喜乐为根，增益一切善缘——财富增长、事业顺遂、修行资粮圆满。财神系本尊是增法的根本本尊。",
    deities: [
      {
        name_zh: "黄财神",
        name_en: "Yellow Dzambhala",
        description: "财富·增益·事业成就",
        credential_key: null,
      },
      {
        name_zh: "白财神",
        name_en: "White Dzambhala",
        description: "增益·消除贫困·资粮圆满",
        credential_key: null,
      },
      {
        name_zh: "绿财神",
        name_en: "Green Dzambhala",
        description: "事业·成就·增益一切",
        credential_key: null,
      },
    ],
  },
  {
    id: "magnetizing",
    name_zh: "怀 · 怀摄",
    name_en: "Magnetizing",
    emoji: "❤️",
    color: "#C2185B",
    bg: "rgba(194,24,91,0.07)",
    border: "rgba(194,24,91,0.25)",
    description: "增强人缘、权威与影响力",
    detail: "怀法以爱力为根，摄持一切有情——增强人缘、姻缘、领导力与教化力。作明佛母（拉则祖古仁波切传承）是怀法主尊。",
    deities: [
      {
        name_zh: "作明佛母",
        name_en: "Kurukulle",
        description: "怀摄法主尊·莲师怀摄本尊·白玉传承",
        credential_key: "simhamukha",
      },
      {
        name_zh: "大自在天",
        name_en: "Ishvara",
        description: "权威·领导力·影响力",
        credential_key: null,
      },
      {
        name_zh: "红度母",
        name_en: "Red Tara",
        description: "人缘·姻缘·怀摄有情",
        credential_key: null,
      },
    ],
  },
  {
    id: "subjugating",
    name_zh: "诛 · 降伏",
    name_en: "Subjugating",
    emoji: "🖤",
    color: "#37474F",
    bg: "rgba(55,71,79,0.07)",
    border: "rgba(55,71,79,0.25)",
    description: "降伏障碍、违缘与恶势力",
    detail: "诛法以悲智为根，降伏一切危害众生的障碍——斩断违缘根源、清净宿世业债。普巴金刚是诛法的根本本尊。",
    deities: [
      {
        name_zh: "普巴金刚",
        name_en: "Vajrakilaya",
        description: "降伏主尊·斩断障碍根源·止贡传承",
        credential_key: "vajrakilaya",
      },
      {
        name_zh: "大黑天",
        name_en: "Mahakala",
        description: "护法主尊·降伏一切违缘",
        credential_key: null,
      },
      {
        name_zh: "忿怒莲师",
        name_en: "Wrathful Padmasambhava",
        description: "降伏·清净障碍·护持修行",
        credential_key: null,
      },
    ],
  },
];
